import { LocationsActionTypes } from './constants';

export const INIT_STATE = {
    loadingLocations: false,
    error: null,
    locations: null,
    creatingLocation: false,
    createdLocation: null,
    deletingLocation: false,
    deletedLocation: false,
    updatingLocation: false,
    updatedLocation: null,
    initialLocation: {
        description: null,
        name: null,
        companyName: null,
        email: null,
        phone: null,
        street1: null,
        street2: null,
        street3: null,
        stateProvince: null,
        postalCode: null,
        cityLocality: null,
        countryCode: null,
    },
};

type LocationsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

//TODO: define data type for orders
type State = {
    loadingAddresses: Boolean,
    error?: null,
    addresses: any,
    creatingLocation: Boolean,
    createdLocation: any,
    deletingLocation: Boolean,
    deletedLocation: Boolean,
    updatingLocation: Boolean,
    updatedLocation: any,
    initialLocation: any,
};

const Locations = (state: State = INIT_STATE, action: LocationsAction): any => {
    switch (action.type) {
        case LocationsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case LocationsActionTypes.READ_ALL_LOCATIONS_REQUEST: {
                    return { ...state, loadingLocations: false, locations: action.payload.data };
                }
                case LocationsActionTypes.CREATE_LOCATION_REQUEST: {
                    return { ...state, creatingLocation: false, createdLocation: action.payload.data };
                }
                case LocationsActionTypes.DELETE_LOCATION_REQUEST: {
                    return { ...state, deletingLocation: false, deletedLocation: true };
                }
                case LocationsActionTypes.UPDATE_LOCATION_REQUEST: {
                    return { ...state, updatingLocation: false, updatedLocation: action.payload.data };
                }
                default:
                    return { ...state, loadingLocations: false, locations: null, error: null, creatingLocation: false, createdLocation: null, deletingLocation: false, deletedLocation: false, updatingLocation: false, updatedLocation: null };
            }

        case LocationsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case LocationsActionTypes.READ_ALL_LOCATIONS_REQUEST: {
                    return { ...state, loadingLocations: false, error: action.payload.error };
                }
                case LocationsActionTypes.CREATE_LOCATION_REQUEST: {
                    return { ...state, creatingLocation: false, error: action.payload.error };
                }
                case LocationsActionTypes.DELETE_LOCATION_REQUEST: {
                    return { ...state, deletingLocation: false, error: action.payload.error };
                }
                case LocationsActionTypes.UPDATE_LOCATION_REQUEST: {
                    return { ...state, updatingLocation: false, error: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case LocationsActionTypes.READ_ALL_ADDRESSES_REQUEST:
            return { ...state, loadingAddresses: true, addresses: null };
        case LocationsActionTypes.CREATE_LOCATION_REQUEST:
            return { ...state, creatingLocation: true, createdLocation: null };
        case LocationsActionTypes.DELETE_LOCATION_REQUEST:
            return { ...state, deletingLocation: true, deletedLocation: false };
        case LocationsActionTypes.UPDATE_LOCATION_REQUEST:
            return { ...state, updatingLocation: true, updatedLocation: null };
        case LocationsActionTypes.RESET_STATE:
            return { ...state, locations: null, error: null, creatingLocation: false, createdLocation: null, deletingLocation: false, deletedLocation: false, updatingLocation: false, updatedLocation: null };
        case LocationsActionTypes.RESET_ALL_ERRORS:
            return { ...state, error: null };
        default:
            return { ...state };
    }
};

export default Locations;
